import * as _4 from 'lodash4';
import { ICampus } from '../../../../interfaces/scheduler_interfaces';

/**
 * Object to array converter thingamabobber
 */
const internalizeCampusObject = function internalizeTermObject(this: any) {
  this.campuses = _4.toArray(this.campuses);
};

/**
 * Set campuses to selected, if they are (You like me, you really like me)
 */
const setSelectedCampuses = function internalizeTermObject(this: any) {
  _4.each(
    this.campuses,
    (campus: ICampus) => {
      campus._selected = _4.includes(this.selected_campuses, campus.id);
    },
    this
  );
};

angular
  .module('capability-ng-scheduler')
  .factory('CampusLocationBuilder', function CampusLocationBuilder(Interface: any) {
    const DTD = {
      campus: {
        type: 'object',
        typeDef: {
          id: 'key',
          is_online: 'boolean',
          is_global: 'boolean',
          name: 'string',
          rank: 'number'
        },
        writeToKey: 'campuses'
      },
      student_term_campus: {
        type: 'array',
        writeToKey: 'selected_campuses'
      },
      prefs_first_visit: 'boolean'
    };

    function CampusLocationDTO(this: any, data: any) {
      Interface.implement(DTD, data, this);
      internalizeCampusObject.call(this);
      setSelectedCampuses.call(this);
    }

    return CampusLocationDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/preferences/builders/campus_location_builder.ts